import {FC, useMemo, useState} from 'react';
import {BODY1, EVENTS, H5, HASH, IMAGE_AVATAR_ALT, ORGANIZATION_INFO, TEAM_MEMBERS} from '@/utils/constants';
import {Box, Tab, Tabs, Typography} from '@mui/material';
import {organizationDetailsStyle} from './OrganizationDetails.style';
import OrgLogo from '@images/organization-example.png';
import OrganizationInfo from '@/components/Admin/Organization/OrganizationInfo';
import TeamMembersInfo from '@/components/Admin/Organization/TeamMembersInfo';
import EventInfo from '@/components/Admin/Organization/EventsInfo';
import {IAdminOrganizationResponse} from '@/utils/types/superAdmin.interface';

export const organizationDetailsTabs = [ORGANIZATION_INFO, TEAM_MEMBERS, EVENTS];

interface OrganizationDetailsProps {
  organization: IAdminOrganizationResponse | null;
  onClose: () => void;
  onSuccess: () => void;
}
const OrganizationDetails: FC<OrganizationDetailsProps> = ({organization, onClose, onSuccess}) => {
  const [activeOrganizationTab, setActiveOrganizationTab] = useState<string>(organizationDetailsTabs[0]);

  const formData = useMemo(() => {
    switch (activeOrganizationTab) {
      case ORGANIZATION_INFO:
        return <OrganizationInfo organization={organization} onClose={onClose} onSuccess={onSuccess} />;

      case TEAM_MEMBERS:
        return <TeamMembersInfo id={organization?.id || null} />;

      case EVENTS:
        return <EventInfo organization={organization} />;

      default:
        return <OrganizationInfo organization={organization} onClose={onClose} onSuccess={onSuccess} />;
    }
  }, [activeOrganizationTab, organization]);

  return (
    <Box sx={organizationDetailsStyle.wrapper}>
      <Box sx={organizationDetailsStyle.content}>
        <Box sx={organizationDetailsStyle.logo}>
          <img src={organization?.logo || OrgLogo} alt={IMAGE_AVATAR_ALT} />
        </Box>
        <Typography variant={H5}>{organization?.name}</Typography>
        <Typography variant={BODY1}>
          {HASH} {organization?.id}
        </Typography>
      </Box>
      <Tabs value={activeOrganizationTab} sx={organizationDetailsStyle.tabs}>
        {organizationDetailsTabs.map((tab: string) => (
          <Tab
            onClick={() => setActiveOrganizationTab(tab)}
            key={tab}
            value={tab}
            label={<Box>{tab}</Box>}
            sx={organizationDetailsStyle.tab}
            disableRipple
          />
        ))}
      </Tabs>
      {/* {formData} */}
      <Box sx={organizationDetailsStyle.tabContent}>{formData}</Box>
    </Box>
  );
};

export default OrganizationDetails;
